import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { Sprout } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { formatApiErrorDetail } from "@/lib/api";

export default function CustomerLogin() {
  const { login, register } = useAuth();
  const nav = useNavigate();
  const [mode, setMode] = useState("login");
  const [form, setForm] = useState({ name: "", email: "", password: "", mobile: "" });
  const [loading, setLoading] = useState(false);
  const set = (k, v) => setForm((f) => ({ ...f, [k]: v }));

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      if (mode === "login") { await login(form.email, form.password); }
      else { await register(form); }
      toast.success("সফল হয়েছে");
      nav("/account");
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail));
    } finally { setLoading(false); }
  };

  const inp = "w-full h-12 px-4 rounded-xl border border-stone-300 bg-white focus:outline-none focus:ring-2 focus:ring-[#1E3A2B]/30";

  return (
    <div className="max-w-md mx-auto px-4 py-12">
      <div className="text-center mb-6">
        <div className="w-14 h-14 rounded-2xl bg-[#1E3A2B] flex items-center justify-center text-[#CA8A04] mx-auto mb-3"><Sprout size={28} /></div>
        <h1 className="text-2xl font-bold text-[#1E3A2B]">{mode === "login" ? "লগইন করুন" : "নতুন অ্যাকাউন্ট"}</h1>
        <p className="text-stone-500 text-sm mt-1">অর্ডার ও কেনাকাটার জন্য</p>
      </div>
      <form onSubmit={submit} className="bg-white rounded-2xl border border-stone-200 p-6 space-y-3">
        {mode === "register" && (
          <>
            <input placeholder="আপনার নাম" value={form.name} onChange={(e) => set("name", e.target.value)} className={inp} data-testid="reg-name" required />
            <input placeholder="মোবাইল নম্বর" value={form.mobile} onChange={(e) => set("mobile", e.target.value)} className={inp} data-testid="reg-mobile" />
          </>
        )}
        <input type="email" placeholder="ইমেইল" value={form.email} onChange={(e) => set("email", e.target.value)} className={inp} data-testid="login-email" required />
        <input type="password" placeholder="পাসওয়ার্ড" value={form.password} onChange={(e) => set("password", e.target.value)} className={inp} data-testid="login-password" required />
        <button type="submit" disabled={loading} className="w-full bg-[#1E3A2B] hover:bg-[#14281D] text-white font-medium h-12 rounded-xl disabled:opacity-50" data-testid="login-submit">
          {loading ? "অপেক্ষা করুন..." : mode === "login" ? "লগইন" : "রেজিস্টার"}
        </button>
      </form>
      <div className="text-center mt-4 text-sm text-stone-600">
        {mode === "login" ? "অ্যাকাউন্ট নেই?" : "অ্যাকাউন্ট আছে?"}{" "}
        <button onClick={() => setMode(mode === "login" ? "register" : "login")} className="text-emerald-700 font-semibold" data-testid="toggle-auth-mode">
          {mode === "login" ? "রেজিস্টার করুন" : "লগইন করুন"}
        </button>
      </div>
      <div className="text-center mt-2">
        <Link to="/" className="text-sm text-stone-400">লগইন ছাড়াই কেনাকাটা করুন →</Link>
      </div>
    </div>
  );
}
